export const SUCCESS = 'GetCategory/success';
export const LOADING = 'GetCategory/loading';
export const FAILED = 'GetCategory/failed';
export const OPTIMISTIC_REORDER = 'FAQ/optimistic_reorder';
export const REVERT_REORDER = 'FAQ/revert_reorder';

export const initialState = {
  dataCategories: [],
  dataCategoriesV2: [],
  dataSubmitFaq: false,
  dataSubmitUpdateFaq: false,
  dataPangkalanFaq: [],
  dataSubPangkalanFaq: [],
  isLoadingCategories: false,
  isLoadingCategoriesV2: false,
  isLoadingSubmitFaq: false,
  isLoadingPangkalanFaq: false,
  isLoadingSubPangkalanFaq: false,
  messageCategories: '',
  messageCategoriesV2: '',
  messageSubmitFaq: '',
  messagePangkalanFaq: '',
  messageSubPangkalanFaq: '',
  previousFaqState: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, data, isLoading, message, key } = action;

  switch (type) {
    case FAILED:
      return {
        ...state,
        [`data${key}`]: initialState[`data${key}`],
        [`isLoading${key}`]: false,
        [`message${key}`]: message,
      };
    case LOADING:
      return {
        ...state,
        [`isLoading${key}`]: isLoading,
        [`message${key}`]: '',
      };
    case SUCCESS:
      return {
        ...state,
        [`data${key}`]: data,
        [`isLoading${key}`]: false,
        [`message${key}`]: '',
      };
    case OPTIMISTIC_REORDER: {
      const { category, updatedItems } = action;
      const previousFaqState = state.dataSubPangkalanFaq;
      const updatedFaqs = state.dataSubPangkalanFaq.map(data => {
        const key = Object.keys(data)[0];
        if (key === category) {
          return { [key]: updatedItems };
        }
        return data;
      });

      return {
        ...state,
        previousFaqState,
        dataSubPangkalanFaq: updatedFaqs
      };
    }
    case REVERT_REORDER:
      return {
        ...state,
        dataSubPangkalanFaq: state.previousFaqState,
        previousFaqState: null
      };
    default:
      return state;
  }
}
